import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initReliabilityMonitoring } from "./reliability";
import "./styles.css";

initReliabilityMonitoring();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
